import script from "./SceneImageWithMultipleTaps.vue?vue&type=script&lang=js"
export * from "./SceneImageWithMultipleTaps.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__